import { setShowSupplierModal } from '../State/showSupplierModal';
import fetchSuppliers from '../Services/fetchSuppliers';

export default () => async (dispatch) => {
  dispatch(setShowSupplierModal(false));
  dispatch(fetchSuppliers());
}
